import authorize from './authorize.js'
import dic from './dic.js'
import word from './word.js'

export default {
  namespaced: true,
  modules: {
    authorize: authorize({ storageKey: 'bis.authorize' }),
    dic: dic(),
    word: word()
  }
}
